import axios from 'axios'
import { BASE_DEV_URL } from '../../config/api.config'
import { setProvidersOnHome, setProviderWiseData } from './casinoHome.slice'

export const providersOnHome =
  (id = 0, name = '') =>
  async (dispatch) => {
    // https://b36.abcd43.com/api/casino/v3/providers?developerId=0
    try {
      if (id === 0) {
        dispatch(setProvidersOnHome({ isLoading: true }))
      } else if (name || id !== 0) {
        dispatch(setProviderWiseData({ isLoading: true }))
      }
      const endPoint = `${BASE_DEV_URL}/casino/v3/providers?developerId=${id}`
      const response = await axios.get(endPoint)
      if (response.status === 200 && response.data.success) {
        if (id === 0) {
          const finalData = response.data.result
            .filter((item) => item.isRng && item?.isB2b)
            .sort((a, b) => a?.index - b?.index)
          dispatch(setProvidersOnHome({ isLoading: false, data: finalData }))
        } else {
          if (name || id !== 0) {
            dispatch(
              setProviderWiseData({
                name: name,
                providerId: id,
                data: response.data.result.sort((a, b) => a?.index - b?.index),
                isLoading: false,
              })
            )
          }
        }

      } else {
        if (id === 0) {
          dispatch(
            setProvidersOnHome({
              isLoading: false,
              error: response.data.message,
            })
          )
        } else if (name || id !== 0) {
          dispatch(
            setProviderWiseData({
              isLoading: false,
              error: response.data.message,
            })
          )
        }
      }
    } catch (error) {
      if (id === 0) {
        dispatch(setProvidersOnHome({ isLoading: false, error: error }))
      } else if (name || id !== 0) {
        dispatch(setProviderWiseData({ isLoading: false, error: error }))
      }
    }
  }
